<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { isBaseMiniApp } from '@/services/base'
import { RouteName } from '@/routes'
import { backButtonCallback } from '@/router'
import router from '@/router'
import { useHapticFeedback } from '@/composables/game/haptic-feedback'
import ArrowLeft from '@/components/icons/ArrowLeft.vue'

const route = useRoute()
const { addHapticFeedback } = useHapticFeedback()

const isVisible = computed(() => {
  if (!isBaseMiniApp) return false
  if (route.name === RouteName.HOME || route.name === RouteName.ONBOARDING) return false
  return !route.meta.hideBackButton

})

const defaultBackCallback = async () => {
  addHapticFeedback('medium')
  await router.push({ name: RouteName.HOME })
}

const currentCallback = computed(() => backButtonCallback.value ?? defaultBackCallback)

function handleClick() {
  currentCallback.value()
}
</script>

<template>
  <div
    v-if="isVisible"
    class="scale-in fixed w-8 h-8 top-2 left-4 flex items-center justify-center z-[90] bg-dark-top-layer/[.66] backdrop-blur-[12px] rounded-full cursor-pointer"
    @click="handleClick"
  >
    <ArrowLeft class="w-5 h-5" />
  </div>
</template>

<style scoped>
</style>
